module.exports = __webpack_public_path__ + "img/eloadas.cc7961c0.jpg";